// src/App.js
import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { PrivateRoute } from './components/PrivateRoute';
import { useAuth0, Auth0Provider } from '@auth0/auth0-react';
import { UserControls } from './components/UserControls';
import { TradovateCreds } from './components/TradovateCreds';
import { Charts } from "./components/Charts";
import { Admin } from './components/Admin';
import { AlgoMetrics } from './components/AlgoMetrics';
import { ErrorBoundary } from './components/ErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import { Footer } from './components/Footer';

function App() {
  const { loading } = useAuth0();

  if (loading) {
    return <div>Loading...</div>;
  }

  const getCallbackURL = () => {
    if (window.location.pathname.includes('/trade/')) {
      return `${window.location.origin}/connect`;
    } else {
      return `${window.location.origin}${window.location.pathname}`;
    }
  }

  return (
    <ErrorBoundary>
      <div className="App">
        <header>
          <Auth0Provider
            domain={process.env.REACT_APP_IAM_DOMAIN}
            clientId={process.env.REACT_APP_IAM_CLIENT_ID}
            authorizationParams={{
              redirect_uri: getCallbackURL(),
              audience: process.env.REACT_APP_IAM_AUDIENCE
            }}
          //cacheLocation="localstorage"
          >
            <BrowserRouter>
              <Header />
              <PrivateRoute>
                <Routes>
                  <Route path="/connect" element={<TradovateCreds />} />
                  <Route path="/trade" element={<UserControls />} />
                  <Route path="/trade/*" element={<UserControls />} />
                  <Route path="/performance" element={<Charts />} />
                  <Route path="/metrics" element={<AlgoMetrics />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path='*' element={<Navigate to='/connect' />} />
                </Routes>
              </PrivateRoute>
              <Footer />
            </BrowserRouter>
          </Auth0Provider>
        </header>
      </div>
    </ErrorBoundary>
  );
}

export default App;